export function snakeToTitleCase(str) {
	return str
		.split('_')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
}

// snakeToTitleCase('my_variable_name');
// "My Variable Name"

export function snakeToTitle(str) {
	const withSpaces = str.replace(/_/g, ' ');
	return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

// snakeToTitle('my_variable_name');
// "My variable name"

export function snakeToCamel(str) {
	return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

// snakeToCamel('my_variable_name');
// "myVariableName"

export function parseApiResponse(data) {
	if (!data || typeof data !== 'object') return null;
  
	// Tenant keys to extract
	const tenantKeys = [
		'access_token',
		'interface_id',
		'tenant_name',
		'logo_url',
		'secondary_logo_url',
		'survey_id',
		'survey_title',
		'survey_description',
	];
  
	// Build tenant object
	const tenant = {};
	for (const key of tenantKeys) {
		if (key in data) {
			const camelKey = snakeToCamel(key);
			tenant[camelKey] = data[key] ?? ''; // fallback to empty string if null/undefined
		}
	}

	// Features transformation
	const features = Array.isArray(data.features)
	  ? data.features.map((feature) => {
			const transformed = {};
			for (const [key, value] of Object.entries(feature)) {
				const camelKey = snakeToCamel(key);
				if (camelKey === "frontendConfig" && typeof value === 'object' ) {
					let deepCamelCaseValue = {}
					for (const [key_d, value_d] of Object.entries(value)) {
						const tk = snakeToCamel(key_d)
						deepCamelCaseValue[tk] = value_d
					}
					transformed[camelKey] = deepCamelCaseValue;
				} else {

					transformed[camelKey] = value;
				}
			}
			if (feature.feature_name) {
				transformed.featureLabel = snakeToTitleCase(feature.feature_name);
			}
			return transformed;
		})
		: [];
  
	// Theme stays mostly the same, but ensure camelCase consistency if desired
	const theme = data.theme ? { ...data.theme } : {};

	// Final assembled object
	return {
		tenant,
		features,
		theme,
	};
}

export function formatISODuration(duration) {
	const match = duration.match(/PT(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?/);
	if (!match) return duration;
	const minutes = match[1] ? parseInt(match[1]) : 0;
	const seconds = match[2] ? Math.round(parseFloat(match[2])) : 0;
	return `${minutes}m ${seconds}s`;
  }